'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _NavigationItem = require('./NavigationItem');

var _NavigationItem2 = _interopRequireDefault(_NavigationItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NavigationItem2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NavigationItem/index.js
// module id = 298
// module chunks = 0